import { render, staticRenderFns } from "./PortfolioChart.vue?vue&type=template&id=060480c0&scoped=true&"
import script from "./PortfolioChart.vue?vue&type=script&lang=js&"
export * from "./PortfolioChart.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioChart.vue?vue&type=style&index=0&id=060480c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060480c0",
  null
  
)

export default component.exports